import { RootComponent, RootComponentEditDialogState } from ".";

const displayColumn = [
  { label: "Name", value: "ichrName" },
  { label: "Position", value: "pstnName" },
  { label: "Company", value: "cmpnyName" },
  { label: "Tel", value: "telNum" },
  { label: "Mail address", value: "mlAdrs" },
];

export const rootComponentInitialState: RootComponent = {
  rootCpntDelFlg: "",
  rootCpntId: "",
  rootCpntName: "",
  dipByRgn: "",
  ownTypeCd: "",
  systemName: "",
  systemId: "",
  subSystemId: "",
  notSysUsg: "",
  alctnTypeCd: "",
  clodSrvcTypeCd: "",
  rgnTypeCd: "",
  acntName: "",
  updateDateTimeMRootCpnt: "",
  rootCpntIchrList: [],
};

export const rootComponentEditDialogInitialState: RootComponentEditDialogState =
  {
    isShow: false,
    isEdit: false,
    isUpdated: false,
    rootComponent: rootComponentInitialState,
    spreadsheetSelectedRowIndex: undefined,
    formValidation: {
      rootCpntName: true,
      ownTypeCd: true,
      systemName: true,
      systemId: true,
      subSystemId: true,
      notSysUsg: true,
      alctnTypeCd: true,
      clodSrvcTypeCd: true,
      rgnTypeCd: true,
      acntName: true,
    },
    dataList: {
      cpntOwnType: [],
      cpntAlctnType: [],
      clodSrvc: [],
      clodSrvcRgn: [],
    },
    displayColumn: displayColumn,
    searchButtonDisabled: false,
    fieldPath: {
      rootCpntId: "rootCpntId",
      rootCpntName: "rootCpntName",
      dipByRgn: "dipByRgn",
      ownTypeCd: "ownTypeCd",
      systemName: "systemName",
      systemId: "systemId",
      subSystemId: "subSystemId",
      notSysUsg: "notSysUsg",
      alctnTypeCd: "alctnTypeCd",
      clodSrvcTypeCd: "clodSrvcTypeCd",
      rgnTypeCd: "rgnTypeCd",
      acntName: "acntName",
    },
  };
